<template>
  <div class="cc-tool">
    <div class="editor-pane">
      <div class="pane-header"><span class="pane-dot input-dot" /><span class="pane-label">{{ $t('tool.ChineseConverter.input') }}</span></div>
      <div class="cc-mode">
        <el-radio-group v-model="mode" size="small" @change="convert">
          <el-radio-button label="s2t">{{ $t('tool.ChineseConverter.toTraditional') }}</el-radio-button>
          <el-radio-button label="t2s">{{ $t('tool.ChineseConverter.toSimplified') }}</el-radio-button>
        </el-radio-group>
      </div>
      <el-input
        type="textarea" v-model="input" class="cc-input"
        :placeholder="mode==='s2t' ? $t('tool.ChineseConverter.phStoT') : $t('tool.ChineseConverter.phTtoS')"
        :rows="8" @input="convert" />
    </div>

    <div class="editor-pane" v-if="output">
      <div class="pane-header"><span class="pane-dot output-dot" /><span class="pane-label">{{ $t('tool.ChineseConverter.output') }}</span></div>
      <div class="cc-output-wrap">
        <code class="cc-output">{{ output }}</code>
      </div>
    </div>
  </div>
</template>

<script>
import { S2T, T2S } from './chinese-map.js'

export default {
  name: 'ChineseConverterTool',
  props: { config: { type: Object, default: function() { return {} } } },
  data: function() { return { input: '', output: '', mode: 's2t' } },
  methods: {
    convert: function() {
      var map = this.mode === 's2t' ? S2T : T2S
      var s = this.input
      var r = ''
      for (var i = 0; i < s.length; i++) {
        var c = s[i]
        r += map[c] || c
      }
      this.output = r
    },
    doAction: function(a) {
      if (a === 'clear') { this.input = ''; this.output = '' }
      if (a === 'copy' && this.output) {
        navigator.clipboard.writeText(this.output).catch(function() {
          var ta = document.createElement('textarea')
          ta.value = this.output
          document.body.appendChild(ta)
          ta.select()
          document.execCommand('copy')
          document.body.removeChild(ta)
        }.bind(this))
      }
    }
  }
}
</script>

<style scoped>
.cc-tool { display: flex; flex-direction: column; gap: 16px; }
.editor-pane { background: #fafbfc; border-radius: 12px; border: 1px solid #ebeef5; padding: 16px 20px; }
.pane-header { display: flex; align-items: center; gap: 8px; margin-bottom: 12px; }
.pane-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
.input-dot { background: #4e7cff; box-shadow: 0 0 6px rgba(78,124,255,.4); }
.output-dot { background: #67c23a; box-shadow: 0 0 6px rgba(103,194,58,.4); }
.pane-label { font-size: 13px; font-weight: 700; color: #1a1f36; }
.cc-mode { margin-bottom: 10px; }
.cc-input >>> textarea { font-size: 14px !important; line-height: 1.8 !important; }
.cc-output-wrap { padding: 12px; background: #fff; border-radius: 8px; border: 1px solid #e4e7ed; min-height: 120px; }
.cc-output { font-size: 16px; line-height: 2; white-space: pre-wrap; word-break: break-all; color: #303133; }
</style>
